<template>
  <div class="homeFooter">
    <div class="footer_warrp">
      <ul class="address">
        <li>
          <img src="../../assets/images/image/foot/group.png" alt>北京市朝阳区望京东路8号锐创国际中心A座5层
        </li>
        <li>
          <img src="../../assets/images/image/foot/group_2.png" alt>010-86208512
        </li>
        <li>
          <img src="../../assets/images/image/foot/group_3.png" alt>bd@xcontract.cn
        </li>
        <li
          style="padding-top:105px;"
        >© 2018-2019 All Rights Reserved | 版权所有：北京智签科技有限公司 | 京ICP备19008281号-1</li>
      </ul>
      <div class="sumbuit">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="email">
            <el-input
              type="text"
              v-model="ruleForm.email"
              placeholder="邮箱"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="photo">
            <el-input
              type="text"
              v-model="ruleForm.photo"
              placeholder="手机号"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item label="给我留言" prop="speak">
            <el-input type="textarea" v-model="ruleForm.speak"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')" style="display:none">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="homeabout">
        <p>
          扫一扫
          <span>|</span>关注我们
        </p>
        <p>
          <img src="../../assets/images/image/foot/Group 4.png">
        </p>
        <p>了解更多产品详情</p>
      </div>
      <div class="platform">© 2018-2019 All Rights Reserved | 版权所有：北京智签科技有限公司 | 京ICP备19008281号-1</div>
    </div>
    <div class="successBox" v-if="successBox">
      <span>{{message}}</span>
    </div>
    <!-- <Dialog
      :visible="successBox"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
      class="hintMessageBox"
    >
      <div slot="dialog">
        <div class="hintMessCon">留言成功</div>
      </div>
    </Dialog>-->
  </div>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
export default {
  components: {},
  data() {
    return {
      successBox: false,
      message: "留言成功",
      ruleForm: {
        photo: "",
        email: "",
        speak: ""
      },
      rules: {
        photo: [
          {
            pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "您输入的格式错误",
            trigger: "blur"
          }
        ],
        email: [
          {
            pattern: /^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "您输入的格式错误",
            trigger: "blur"
          }
        ],
        speak: [
          { required: true, message: "请输入留言", trigger: "blur" },
          { max: 50, message: "最多输入50个字", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    present() {
      this.$router.push({ path: "/personal/home" });
    },
    submitForm(formName) {
      if (
        !/^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/.test(
          this.ruleForm.photo
        ) &&
        !/^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          this.ruleForm.email
        )
      ) {
        return;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          var params = {
            email: this.ruleForm.email,
            mobile: this.ruleForm.photo,
            message: this.ruleForm.speak
          };
          BaseApi.createRpcToken(" /common/leaveMessage", params)
            .then(data => {
              if (data.datas.success == true) {
                this.successBox = true;
                this.resetForm(formName);
                setTimeout(() => {
                  this.successBox = false;
                }, 2000);
              }
            })
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeDialog(data) {
      this.successBox = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  components: {
    Dialog
  }
};
</script>
<style lang="scss" scope>
.homeFooter {
  .sumbuit {
    float: right;
    padding-top: 64px;
    padding-left: 87px;
    .el-input {
      .el-input__inner {
        background-color: rgba(0, 0, 0, 0);
        border-radius: 0;
        padding-left: 0;
      }
      .el-form-item.is-success .el-input__inner {
        border-color: 1px solid #b4b4b4;
      }
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      content: "";
    }
    .el-form-item__label {
      color: #b4b4b4;
      float: none;
    }
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-form-item__content {
      line-height: 36px;
    }
    .el-form-item.is-success .el-textarea__inner {
      border-color: 1px solid #b4b4b4;
    }
    textarea {
      resize: none;
      background-color: rgba(0, 0, 0, 0);
      border-color:#b4b4b4 !important;
      color: #b4b4b4;
    }
    input {
      width: 360px;
      height: 36px;
      background: rgba(0, 0, 0, 0);
      border: none;
      border-bottom: 1px solid #b4b4b4;
      outline: none;
      color: #b4b4b4;
    }
    .liuyan {
      width: 360px;
      height: 36px;
      background: rgba(0, 0, 0, 0);
      border: 0.5px solid #b4b4b4;
      outline: none;
      color: #b4b4b4;
    }
    p {
      font-size: 14px;
      color: #b4b4b4;
      margin-top: 10px;
      margin-bottom: 4px;
    }
    button {
      width: 360px;
      height: 33px;
      line-height: 33px;
      background: rgba(0, 0, 0, 0);
      margin-top: 20px;
      border: 0.5px solid #b4b4b4;
      color: #b4b4b4;
      padding: 0;
    }
  }
}
</style>

<style lang="scss" scope>
.homeFooter {
  width: 100%;
  height: 360px;
  background: #37393b;
  .sumbuit {
    float: right;
    padding-top: 64px;
    padding-left: 87px;
    .el-input {
      .el-input__inner {
        background-color: rgba(0, 0, 0, 0);
        border-radius: 0;
        padding-left: 0;
      }
      .el-form-item.is-success .el-input__inner {
        border-color: 0.5px solid #b4b4b4;
      }
      .el-form-item.is-success .el-input__inner {
        border-color: 0.5px solid #b4b4b4;
      }
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      content: "";
    }
    .el-form-item__label {
      color: #b4b4b4;
      float:none;
    }
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-form-item.is-success .el-textarea__inner {
      border-color: 0.5px solid #b4b4b4;
    }
    textarea {
      resize: none;
      background-color: rgba(0, 0, 0, 0);
      border-color:#b4b4b4 !important;
      color: #b4b4b4;
    }
    input {
      width: 360px;
      height: 36px;
      background: rgba(0, 0, 0, 0);
      border: none;
      border-bottom: 1px solid #b4b4b4;
      outline: none;
      color: #b4b4b4;
    }
    .liuyan {
      width: 360px;
      height: 36px;
      background: rgba(0, 0, 0, 0);
      border: 1px solid #b4b4b4;
      outline: none;
      color: #b4b4b4;
    }
    p {
      font-size: 14px;
      color: #b4b4b4;
      margin-top: 10px;
      margin-bottom: 4px;
    }
    button {
      width: 360px;
      height: 33px;
      line-height: 33px;
      background: rgba(0, 0, 0, 0);
      margin-top: 20px;
      border: 0.5px solid #b4b4b4;
      color: #b4b4b4;
      padding: 0;
    }
  }
  .address {
    color: #b4b4b4;
    font-size: 14px;
    list-style: none;
    line-height: 24px;
    padding-top: 110px;
    float: left;
    img {
      vertical-align: middle;
      padding-right: 12px;
    }
  }
  .footer_warrp {
    max-width: 1180px;
    margin: 0 auto;
  }
  .homeabout {
    float: right;
    padding-top: 108px;
    display: none;
    p:nth-child(1) {
      font-size: 14px;
      color: #b4b4b4;
    }
    span {
      font-size: 14px;
      color: rgb(200, 200, 200);
      margin: 0 15px;
    }
    p {
      margin: 5px 0;
      img {
        width: 132px;
        height: 132px;
      }
    }
    p:nth-child(3) {
      font-size: 16px;
      color: #b4b4b4;
    }
  }
  .platform {
    display: none;
    color: #b4b4b4;
    font-size: 14px;
  }
  .successBox {
    position: fixed;
    z-index: 99999;
    width: 120px;
    background-color: rgba(000, 000, 000, 0.4);
    color: rgb(220, 220, 220);
    text-align: center;
    height: 30px;
    line-height: 30px;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -60px;
    font-size: 14px;
    letter-spacing: 1px;
  }
}
</style>
